// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8bbf821a","946":"65568695"}[chunkId] + ".chunk.js";
};